import { useLocalStorageState } from "@v2/hooks/useLocalStorage";
import { z } from "zod";

export function useChatSidebar() {
  const [open, setOpen] = useLocalStorageState(
    "replo.editor.chatSidebarOpen",
    false,
    { schema: z.boolean() },
  );
  const toggle = () => setOpen((v) => !v);
  return { open, setOpen, toggle } as const;
}
